import { render, staticRenderFns } from "./ListagemDosGruposEconomicosPorCliente.vue?vue&type=template&id=769da6db&"
import script from "./ListagemDosGruposEconomicosPorCliente.vue?vue&type=script&lang=ts&"
export * from "./ListagemDosGruposEconomicosPorCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports